import { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { projects, projectOrder } from "../data/projects";
import { CaseStudy } from "../components/CaseStudy";

export default function ProjectPage() {
  const { slug } = useParams();
  const p = projects[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!p) return <Navigate to="/" replace />;

  const idx = projectOrder.indexOf(slug);
  const nextSlug = projectOrder[(idx + 1) % projectOrder.length];
  const next = projects[nextSlug];

  return (
    <div className="pj-page" data-testid="project-page">
      <div className="pj-hero">
        <div className="pj-wrap">
          <Link to="/" className="inbox-back pj-back" data-testid="project-back-link"><ArrowLeft className="icon" /> All projects</Link>
          <div className="pj-num">{p.num}</div>
          <div className="pj-tag">{p.tag}{p.inDevelopment && <span className="pj-dev-badge">In development</span>}</div>
          <h1 className="pj-title" data-testid="project-title">{p.title}</h1>
          <div className="wc-chips">{p.chips.map((c, i) => <span className="wc-chip pj-chip" key={i}>{c}</span>)}</div>
        </div>
      </div>

      <div className="pj-wrap">
        <CaseStudy p={p} />
        <div className="pj-next">
          <Link to={`/project/${nextSlug}`} className="pj-next-link" data-testid="project-next-link">
            <span className="pj-next-label">Next project</span>
            <span className="pj-next-title">{next.title} <ArrowRight className="icon" /></span>
          </Link>
        </div>
      </div>

      <footer>
        <div className="fcopy">© 2026 Paulyn Duman · UNSSC Knowledge Centre for Sustainable Development · Bonn, Germany</div>
        <div className="ftag">UN 2.0 · SDGs · Knowledge Systems</div>
      </footer>
    </div>
  );
}
